import { Pipe, PipeTransform } from '@angular/core';
import { IChatFormatBlock } from './chat-format.pipe';
import { IChatTruncatedBlocks, truncateChatBlocks } from './chat-truncate.util';

/** Shortens `chatFormat` output for "Read More"; `isTruncated` stays true while expanded so "Read Less" can be offered. */
@Pipe({ name: 'chatTruncate', standalone: true, pure: true })
export class ChatTruncatePipe implements PipeTransform {
  public transform(blocks: IChatFormatBlock[], limit: number, isExpanded: boolean): IChatTruncatedBlocks {
    const truncated = truncateChatBlocks(blocks, limit);
    return isExpanded ? { blocks, isTruncated: truncated.isTruncated } : truncated;
  }
}
